import React from "react";
import { WrapperPage } from "../../../components/shared/WrapperPage";
import SuspenseComp from "../../../components/shared/SuspenseComp";
import { SkeletonPagePolaris } from "../../../components/shared/SkeletonPagePolaris";
import TiktokEditPush from "../../../components/tiktok/push-products/TiktokEditPush"
import { useParams } from "react-router-dom";

export default function TiktokEditPushPage() {
	const { id } = useParams();

	return (
		<WrapperPage>
			<SuspenseComp fallback={<SkeletonPagePolaris />}>
				<TiktokEditPush id={id}/>
			</SuspenseComp>
		</WrapperPage>
	);
}
